import React, { ReactNode } from 'react';

import { Crumb } from '../Breadcrumbs';
import { Breadcrumbs, Tabs } from '../index';
import { TabItem } from '../Tabs/types';

type Props = {
  children: ReactNode;
  breadCrumbsOptions?: Crumb[];
  tabsItems?: TabItem[];
  rightTabsContent?: ReactNode;
  dataTestId?: string;
};

const SettingsContentWrapper = ({
  children,
  breadCrumbsOptions,
  rightTabsContent,
  tabsItems,
  dataTestId
}: Props): JSX.Element | null => {
  return (
    <>
      {breadCrumbsOptions && (
        <Breadcrumbs dataTestId={`breadcrumbs-${dataTestId}`} items={breadCrumbsOptions} />
      )}
      {tabsItems && (
        <Tabs dataTestId={`tabs-${dataTestId}`} rightContent={rightTabsContent} items={tabsItems} />
      )}
      {children}
    </>
  );
};

export default SettingsContentWrapper;
